// Wrap a row/cell click handler so a click-drag text selection does NOT fire it.
// Lets users highlight a name (to copy) without triggering navigation/drill.
// Usage: onClick={clickUnlessSelecting(() => loadCollector(col))}
export const clickUnlessSelecting = (fn) => (e) => {
  const sel = window.getSelection && window.getSelection();
  if (sel && sel.toString()) return; // an active text selection → user was selecting, not clicking
  fn(e);
};
